/**
 * MoonCard — Liquid Glass surface showing current moon phase + headline + body.
 * Verbatim port of mobile.html `.moon-card`. Uses ReactNode for headline/body
 * so callers compose `&nbsp;` via JSX (no dangerouslySetInnerHTML — XSS-safe).
 */
import type { ReactElement, ReactNode } from "react";

export interface MoonCardProps {
  readonly phaseLabel: string;
  readonly position: string;
  readonly headline: ReactNode;
  readonly body: ReactNode;
}

function MoonGlyph(): ReactElement {
  return (
    <svg viewBox="0 0 36 36" aria-hidden="true">
      <circle cx="18" cy="18" r="14" fill="#252B45" stroke="#9AA0B0" strokeWidth="0.8" />
      <path d="M18 4a14 14 0 0 1 0 28a9 9 0 0 0 0-28z" fill="#F5F2EC" />
    </svg>
  );
}

export function MoonCard({ phaseLabel, position, headline, body }: MoonCardProps): ReactElement {
  return (
    <article className="moon-card">
      <div className="phase">
        <MoonGlyph />
        <div className="phase-text">
          <div className="l">{phaseLabel}</div>
          <div className="v">{position}</div>
        </div>
      </div>
      <h3>{headline}</h3>
      <p>{body}</p>
    </article>
  );
}

/** Non-breaking space helper for inline JSX composition. */
export const NBSP = " ";
